// AUTO-GENERATED — DO NOT EDIT. Run `bun run plugin:regen` to update.
import type {
	PluginClientModule,
	PluginHomeTile,
	PluginManifest,
	PluginRouteFactory,
	PluginSidebar,
} from "@d12labs/plugins/types";
import { client as ai_chatClient } from "./ai-chat/client";
import { client as crmClient } from "./crm/client";
import { client as fitstreakClient } from "./fitstreak/client";
import { client as kbClient } from "./kb/client";
import { client as ledgerClient } from "./ledger/client";
import { client as meeting_perfClient } from "./meeting-perf/client";
import { client as notesClient } from "./notes/client";
import { client as speech_coachClient } from "./speech-coach/client";
import { client as uploadsClient } from "./uploads/client";

const modules: Record<string, PluginClientModule> = {
	"ai-chat": ai_chatClient,
	crm: crmClient,
	fitstreak: fitstreakClient,
	kb: kbClient,
	ledger: ledgerClient,
	"meeting-perf": meeting_perfClient,
	notes: notesClient,
	"speech-coach": speech_coachClient,
	uploads: uploadsClient,
};

const entries = Object.entries(modules);

export const pluginManifests: PluginManifest[] = entries.map(([, m]) => m.manifest);

export const pluginRouteFactories: Record<string, PluginRouteFactory> = Object.fromEntries(
	entries.map(([name, m]) => [name.replace(/-/g, "_"), m.createRoutes]),
);

export const pluginSidebars: Record<string, PluginSidebar> = Object.fromEntries(
	entries.filter(([, m]) => m.sidebar).map(([name, m]) => [name, m.sidebar as PluginSidebar]),
);

export const pluginHomeTiles: Record<string, PluginHomeTile> = Object.fromEntries(
	entries.filter(([, m]) => m.homeTile).map(([name, m]) => [name, m.homeTile as PluginHomeTile]),
);
